import axiosInstance from "../api/axios";

export const userSignUp = async (payload) => {
  const res = await axiosInstance.post("/api/user/register", payload);
  return res.data;
};

export const userSignIn = async (payload) => {
  const res = await axiosInstance.post("/api/user/login", payload);
  return res.data;
};

export const forgotPassword = async (payload) => {
  const res = await axiosInstance.post("/api/user/forgot-password", payload);
  return res.data;
};

export const verifyOtp = async (payload) => {
  const res = await axiosInstance.post("/api/user/verify-email", payload);
  return res.data;
};

export const resetPassword = async (payload) => {
  const res = await axiosInstance.post("/api/user/reset-password", payload);
  return res.data;
};

export const socialLogin = async (payload) => {
  const res = await axiosInstance.post("/api/user/social-login", payload);
  return res.data;
};

export const deleteAccount = async () => {
  const res = await axiosInstance.delete("/api/user/delete-profile");
  return res.data;
};

export const logoutUser = async () => {
  const res = await axiosInstance.post("/api/user/logout");
  return res.data;
};

export const verifyUser = async (id) => {
  const res = await axiosInstance.post(`/api/user/verified-email?id=${id}`);
  return res.data;
};

export const addToMailchimp = async (payload) => {
  const res = await axiosInstance.post("/api/user/add-to-mailchimp", payload);
  return res.data;
}
